import { Modal, ModalBody } from "react-bootstrap";
import moment from "moment";
import "moment/locale/ru";

import styles from "./ModuleModal.module.css";

const ModalItem = ({ lesson, color }) => {
  return (
    <div className="col-12 col-sm-4 p-2">
      <div
        style={{ backgroundColor: color + "33" }}
        className={styles.moduleItemWrapper}
      >
        <div className={styles.modalItemLesson}>
          <span>Тема урока:</span>
          <h1 className="m-0">{lesson.theme}</h1>
        </div>
        <div className={styles.modalItemLesson}>
          <span>Дата:</span>
          <h1 className="m-0">{moment(lesson.date).format("D MMM YYYY")}</h1>
        </div>
        <div className={styles.modalItemLesson}>
          <span>Присутствие:</span>
          <div className="d-block">
            {lesson.visit ? (
              <i
                style={{ color: "#5dd001" }}
                className="fa fa-check"
                aria-hidden="true"
              ></i>
            ) : (
              <i
                style={{ color: "#fe5f48" }}
                className="fa fa-times"
                aria-hidden="true"
              ></i>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const ModuleModal = ({ module, showModal, setShowModal }) => {
  const { course, lessons } = module;
  return (
    <Modal
      style={{ paddingLeft: 0 }}
      onHide={() => setShowModal(false)}
      show={showModal}
      centered
    >
      <ModalBody>
        <button
          type="button"
          className="close"
          onClick={() => setShowModal(false)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div
          style={{ backgroundColor: course.module.color }}
          className="lesson-detail-top"
        ></div>
        <h1 className="my-3 mx-4">Уроки модуля</h1>
        <div className="row mx-3 mb-3">
          {lessons &&
            lessons.map((lesson, index) => {
              return (
                <ModalItem
                  key={index}
                  lesson={lesson}
                  color={course.module.color}
                />
              );
            })}
        </div>
      </ModalBody>
    </Modal>
  );
};
